import { render, staticRenderFns } from "./ListaAulasTopico.vue?vue&type=template&id=b86928ba&scoped=true&"
import script from "./ListaAulasTopico.vue?vue&type=script&lang=js&"
export * from "./ListaAulasTopico.vue?vue&type=script&lang=js&"
import style0 from "./ListaAulasTopico.vue?vue&type=style&index=0&id=b86928ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86928ba",
  null
  
)

export default component.exports